<template>
  <div
    data-component="app-launcher-header-agent-info"
    :class="{ 'is-active': isOpen }"
    @click.stop="isOpen = !isOpen"
  >
    <agent-avatar
      :avatar="avatar"
      :person="agent"
    />

    <or-icon :icon="icon" />

    <agent-profile-popup
      v-if="isOpen"
      :avatar="avatar"
      :agent="agent"
      :app-version="appVersion"
      :options="availableOptions"
      @option-click="onOptionClick"
      @sign-out="onSignOut"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';
import { OrIconV3 as OrIcon } from '@onereach/ui-components-25';
import { AgentAvatar } from '@onereach/hitl-base-avatars';

import { AgentProfilePopup } from '@/modules/app-header/components/agent-profile-popup';
import { AVATAR_PROP, AGENT_PROP } from '../constants';

export default defineComponent({
  name: 'AppLauncherHeaderAgentInfo',
  components: {
    AgentAvatar,
    OrIcon,
    AgentProfilePopup,
  },
  props: {
    avatar: AVATAR_PROP,
    agent: AGENT_PROP,
    appVersion: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isOpen: false,
      DEFAULT_OPTIONS: [
        {
          key: 'open-profile',
          label: this.$t('HITL.common.labels.edit-profile'),
        },
      ],
    };
  },
  computed: {
    icon() {
      return this.isOpen ? 'expand_less' : 'expand_more';
    },
    availableOptions() {
      return this.options.concat(this.DEFAULT_OPTIONS);
    },
  },
  mounted() {
    document.addEventListener('click', this.onBlur);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onBlur);
  },
  methods: {
    onOptionClick(option: string) {
      this.isOpen = false;
      this.$emit('option-click', option);
    },
    onSignOut() {
      this.isOpen = false;
      this.$emit('sign-out');
    },
    onBlur() {
      this.isOpen = false;
    },
  },
});
</script>

<style lang="scss" scoped>
@use '@/styles' as *;

[data-component='app-launcher-header-agent-info'] {
  display: flex;
  align-items: center;
  gap: var(--s-3);
  position: relative;
  color: var(--or-c-on-background);
  cursor: pointer;

  @include max-xsm {
    [data-component='agent-profile-popup'] {
      width: calc(100vw - 1.5rem);
      right: -0.75rem !important;
    }
  }

  [data-component='agent-profile-popup'] {
    position: absolute;
    top: calc(100% + var(--s-3));
    right: 0;
  }

  .agent-avatar {
    height: 2rem !important;
    width: 2rem !important;
    cursor: pointer;
  }
}
</style>
